<template>
  <div>
    <b-modal :id="modal_id" title="マスタ > 発注先 > 編集" size="xl" :header-bg-variant="'dark'" :header-text-variant="'light'"
      :body-bg-variant="'light'" @hide="closeModal" hide-footer centered scrollable>
      <!-- 自社 -->
      <form @submit.prevent="updateHattyuCompany">
        <div v-if="errors.length != 0">
          <ul v-for="e in errors" :key="e">
            <li>
              <font color="red">{{ e }}</font>
            </li>
          </ul>
        </div>
        <div class="form-inline" style="margin: 10px 0px">
          <label>発注先コード</label>
          <b-input v-model="hattyu_company.company_code" type="text" />
          &nbsp;&nbsp;
          <label>発注先</label>
          <b-input v-model="hattyu_company.company_name" type="text" style="width: 300px" />
          &nbsp;&nbsp;
          <label>発注先(ひらがな)</label>
          <b-input v-model="hattyu_company.company_name_kana" type="text" style="width: 300px" />
        </div>
        <div class="form-inline" style="margin: 10px 0px">
          <label>郵便番号</label>
          <b-input v-model="hattyu_company.zip_code" type="text" placeholder="" style="width: 100px" />
          <b-button @click="searchAddress" style="width: 110px !important">
            <b-icon icon="search"></b-icon>住所検索
          </b-button>
          &nbsp;&nbsp;
          <label>住所1</label>
          <b-input v-model="hattyu_company.address1" type="text" style="width: 300px" />
          &nbsp;&nbsp;
          <label>住所2</label>
          <b-input v-model="hattyu_company.address2" type="text" style="width: 200px" />
          &nbsp;&nbsp;
          <label>住所3</label>
          <b-input v-model="hattyu_company.address3" type="text" style="width: 150px" />
        </div>
        <div>
          <b-button type="submit" variant="primary" style="margin-left: 910px" :disabled="pms_master_hattyu_company < 2">
            <b-icon icon="save"></b-icon>&nbsp;保存
          </b-button>
          &nbsp;
          <b-button @click="delHattyuCompany(hattyu_company_id)" variant="danger"
            :disabled="pms_master_hattyu_company < 2">
            <b-icon icon="save"></b-icon>&nbsp;削除
          </b-button>
        </div>

      </form>
      <hr />
      <!-- 担当者 -->
      <div>担当者</div>
      <div>
        <div style="width: 800px; ">
          <b-table-filter :maxHeight="maxHeight" :filter_list="filter_list" :filter_val="filter_val" :busy="busy"
            :data_list_field="data_list_field" :data_list="data_list" @on_edit='onEdit' @on_delete='onDelete'
            :filter_enable="false" :nav_flg="false" :edit_disabled="pms_master_hattyu_company < 2" />
        </div>
      </div>
      <div style="margin: 5px 0px 0px 0px">
        {{ data_list.length }}件&nbsp;&nbsp;
        <b-button @click="onEdit(-1)" ref="btnShow" variant="info" class="icon_btn_w"
          :disabled="pms_master_hattyu_company < 2">
          <b-icon icon="plus" aria-hidden="true"></b-icon>
        </b-button>
      </div>
      <!-- モーダル 担当者詳細 -->
      <b-modal id="modal-hattyu-person" :title="title" :header-bg-variant="'dark'" :header-text-variant="'light'"
        :body-bg-variant="'light'" hide-footer centered>
        <div class="modal_div">
          <div class="form-inline">
            <label>担当者名</label>
            <b-input v-model="hattyu_person.person_name" type="text" />
          </div>
          <div class="form-inline">
            <label>TEL</label>
            <b-input v-model="hattyu_person.tel" type="text" style="" />
          </div>
          <div class="form-inline">
            <label>FAX</label>
            <b-input v-model="hattyu_person.fax" type="text" />
          </div>
          <div class="form-inline">
            <label>Mail</label>
            <b-input v-model="hattyu_person.mail" type="text" />
          </div>
        </div>
        <div class="modal-footer">
          <b-button @click="$bvModal.hide('modal-hattyu-person')">
            <b-icon icon="x"></b-icon>取消
          </b-button>
          <b-button @click="onDelete" variant="danger" class="" :disabled="this.hattyu_person.id == null">
            <b-icon icon="save"></b-icon>&nbsp;削除
          </b-button>
          <b-button variant="primary" @click="updateHattyuPerson">
            <b-icon icon="save"></b-icon>&nbsp;保存
          </b-button>
        </div>
      </b-modal>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
const jsonpAdapter = require('axios-jsonp');
export default {
  props: ['modal_id'],
  components: {
  },
  data: function () {
    return {
      hattyu_company_id: 0,
      hattyu_company: [],
      // table
      busy: false,
      filter_list: new Array(15),
      filter_val: new Array(15),
      data_list: [],
      data_list_field: [
        { key: "edit", label: "編集", thStyle: { width: "60px", textAlign: "center" }, tdClass: 'text-center', sortable: false, filter: false, edit: true },
        { key: "person_name", label: "名前", thStyle: { width: "150px" }, sortable: true, filter: 'input' },
        { key: "tel", label: "TEL", thStyle: { width: "150px" }, sortable: true, filter: 'input' },
        { key: "fax", label: "FAX", thStyle: { width: "150px" }, sortable: true, filter: 'input' },
        { key: "mail", label: "Mail", thStyle: {}, sortable: true, filter: 'input' },
      ],
      hattyu_person: [],
      modal: '',
      title: '',
      msg: 'msg',
      showModal: false,
      deleteTarget: -1,
      errors: [],
      maxHeight: document.documentElement.scrollHeight - 350 + "px"
    }
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    closeModal: function (id) {
      this.$emit('close_modal', id);
    },
    setHattyuCompanyId: function (hattyu_company_id) {
      this.hattyu_company_id = hattyu_company_id;
      this.getHattyuCompany();
    },

    // 発注 - 会社 取得
    getHattyuCompany: function () {
      axios
        .get(`/master_hattyu_company/get_hattyu_company/${this.hattyu_company_id}`)
        .then(response => {
          this.hattyu_company = response.data.hattyu_company;
          this.getHattyuPeople();
        })
    },
    // 発注 - 会社 更新
    updateHattyuCompany: function () {
      axios
        .patch(`/master_hattyu_company/update_hattyu_company`, { hattyu_company: this.hattyu_company })
        .then(response => {
          (this.hattyu_company = response.data);
          alert("保存しました。");
        })
    },
    // 発注 - 会社 削除
    delHattyuCompany: function (hattyu_company_id) {
      if (confirm('削除しますか？')) {
        axios
          .delete(`/master_hattyu_company/del_hattyu_company/${hattyu_company_id}`)
          .then(response => {
            alert("削除しました。");
            this.$root.$emit('bv::hide::modal', this.modal_id)
          })
      }
    },
    // 担当者 取得
    getHattyuPeople: function () {
      axios
        .get(`/master_hattyu_company/get_hattyu_people/${this.hattyu_company.id}`)
        .then(response => {
          (this.data_list = response.data.hattyu_people);
        })
    },
    // 担当者モーダル 表示
    onEdit: function (hattyu_person_id) {
      if (hattyu_person_id == -1){
        this.title = "担当者 > 追加"
      }else{
        this.title = "担当者 > 編集"
      }
      axios
        .get(`/master_hattyu_company/get_person/${hattyu_person_id}`)
        .then(response => {
          (this.hattyu_person = response.data);
          this.$root.$emit('bv::show::modal', 'modal-hattyu-person')
        })
    },
    // 担当者 更新
    updateHattyuPerson: function () {
      axios
        .patch(`/master_hattyu_company/update_hattyu_person`, { hattyu_company: this.hattyu_company, hattyu_person: this.hattyu_person })
        .then(response => {
          (this.hattyu_person = response.data);
          this.getHattyuPeople();
          this.$root.$emit('bv::hide::modal', 'modal-hattyu-person')
        })
    },
    // 担当者 削除
    onDelete: function () {
      if (confirm('削除しますか？')) {
        axios
          .delete(`/master_hattyu_company/del_hattyu_person/${this.hattyu_person.id}`)
          .then(response => {
            alert("削除しました。")
            this.$root.$emit('bv::hide::modal', 'modal-hattyu-person')
            this.getHattyuPeople();
          })
      }
    },
    // 郵便番号検索
    searchAddress: function () {
      const zipCode = this.hattyu_company.zip_code;
      axios
        .get(`https://api.zipaddress.net/?zipcode=${zipCode}`, { adapter: jsonpAdapter })
        .then(rs => {
          const response = rs.data;
          if (response.code == '400') {
            alert('郵便番号は数値7桁で入力してください');
          } else {
            this.hattyu_company.address1 = response.pref + response.city + response.town
          }
        })
    },

  }
}
</script>

<style scoped></style>